<template>
  <div class="iframe-qr-code-container" id="bind_dd_container"/>
</template>

<script>
import {getDingtalkAppId} from "@/api/common";
import {bindDingDing, getAuth} from "@/api/login";
import {getAuthUser} from "@/utils/auth";

const user = getAuthUser()

export default {
  name: "BindDDQRCode",
  created() {
    this.init()
  },
  methods: {
    async init() {
      await this.callbackScan()
      await this.renderQrCode()
    },
    /**
     * 渲染二维码
     * @returns {Promise<boolean>}
     */
    async renderQrCode() {
      //获取钉钉应用ID
      const {model} = await getDingtalkAppId()
      const app_id = model && model.app_id ? model.app_id : false
      if (!app_id) {
        this.$message.error('绑定钉钉异常app_id，请联系管理员！')
        return false;
      }

      const dingAppId = app_id
      let uri = `${window.location.origin}${window.location.pathname}`
      let redirectUrl = encodeURIComponent(uri);
      let goto = encodeURIComponent(`https://oapi.dingtalk.com/connect/qrconnect?appid=${dingAppId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${redirectUrl}`)
      // eslint-disable-next-line no-undef
      DDLogin({
        id: "bind_dd_container",
        goto: goto, //请参考注释里的方式
        style: "border:none;background-color:#FFFFFF;",
        width: "210",
        height: "240"
      });
      let handleMessage = function (event) {
        const origin = event.origin;
        if (origin === "https://login.dingtalk.com") { //判断是否来自ddLogin扫码事件。
          const loginTmpCode = event.data; //拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          window.parent.postMessage(loginTmpCode, '*');
          //1.跳转到主页面，微应用自身截取code比对用户信息
          window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${dingAppId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=http://&loginTmpCode=${loginTmpCode}`;
        }
      };
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessage, false);
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessage);
      }
    },
    /**
     * 扫码后回调
     */
    async callbackScan() {
      // 飞书 OAuth 回调同样携带 code 参数（state=feishu），不能当作钉钉扫码码处理
      if (this.getQueryVariable('state') === 'feishu') {
        return;
      }
      let code = this.getQueryVariable('code')
      if (!code) {
        return;
      }
      const form = {
        code: code,
        account: user.username,
        has_user_bind: true
      }
      const _this = this
      const res = await bindDingDing(form);
      if (!res.success) {
        return;
      }

      let newQuery = JSON.parse(JSON.stringify(this.$route.query)) // 先拷贝一个一模一样的对象
      delete newQuery.code
      await _this.$router.replace({query: newQuery}) //再把新的替换了
      const loading = _this.$loading({
        lock: true,
        text: '同步钉钉用户信息中...请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.9)'
      });
      const {model} = await getAuth()
      await _this.$store.dispatch('login', model);
      loading.close();
      _this.$emit('success')
      setTimeout(() => {
        _this.$message.success('绑定成功')
      }, 10)
    },
    /**
     *
     * @param variable
     * @returns {boolean|string}
     */
    getQueryVariable(variable) {
      const query = window.location.search.substring(1);
      const vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return false;
    },
  }
}
</script>

<style lang="scss">
.iframe-qr-code-container {
  position: absolute;
  top: -37px;
  transform: scale(0.86, 0.9);
}
</style>